import Vue from 'vue'
import Router from 'vue-router'
import person from '@/pages/person-apply'
import join from '@/pages/apply-for-joining'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: '申请代理',
    //   component: person
    // },
    // {
    //   path: '/',
    //   name: '商家入驻',
    //   component: join
    // },
    {
      path: '/person',
      name: '',
      component: person
    },
    {
      path: '/join',
      name: '',
      component: join
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js